import { createFileRoute } from '@tanstack/react-router';

import { requirePermission } from '@/app/guards';
import { BlogPostCreatePage, blogCategoriesQueryOptions } from '@/features/blog';

export const Route = createFileRoute('/_authed/_active/s/$storeId/content/blog/new')({
  staticData: { crumb: 'blog:new' },
  beforeLoad: ({ context }) => {
    requirePermission(context.me, 'content.write');
  },
  loader: ({ context, params }) =>
    context.queryClient
      .query({ ...blogCategoriesQueryOptions(params.storeId), staleTime: 'static' })
      .catch(() => undefined),
  component: BlogPostCreatePage,
});
